module.exports = __webpack_public_path__ + "static/media/fblogo.77d199c5.png";